import { Injectable } from '@angular/core';
import { UserPermissionService } from '../data/services/user-permission.service';

@Injectable()
export class GuardService {
  constructor(private userPermissionService: UserPermissionService) {}

  private readonly reportingPaths = ['weld-stats', 'welder-stats', 'welder-stamp-id-history'];

  //#region 'Variables'
  //#endregion

  //#region 'Public Methods'
  public validateUserPermissions(path: any): boolean {
    const PERMISSIONS = JSON.parse(localStorage.getItem('user'));

    if (PERMISSIONS) {
      if (path === 'welder-qualification') {
        return this.userPermissionService.hasPermission('view welder qualification', PERMISSIONS);
      }
      if (PERMISSIONS.permissions.includes('system admin')) {
        return true;
      } else {
        if (path === 'log' && PERMISSIONS.permissions.includes('view weld log')) {
          return true;
        } else if (
          (path === 'stats' || this.reportingPaths.includes(path)) &&
          PERMISSIONS.permissions.includes('view statistics')
        ) {
          return true;
        } else if (path === 'continuity' && PERMISSIONS.permissions.includes('view welder continuity')) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }
  //#endregion
}
